export function checkOrientation(orientation) {
  switch (orientation) {
    case "BOTTOM_TOP":
      return "to top,";
    case "TOP_BOTTOM":
      return "to bottom,";
    case "LEFT_RIGHT":
      return "to right,";
    case "RIGHT_LEFT":
      return "to left,";
    default:
      return "";
  }
}
export default checkOrientation;
